export default "__VITE_ASSET__LVwg_tBm__"